import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
  selector: "[appHighlight]"
})
export class HighlightDirective {
  private _content: string;
  private _searchTerm: string;
  private separatedText = <any>([]);
  private separatedSearchedText = <any>([]);
  private final = "";
  searchPattern: any;
  matchpattern: any;
  splitFlag = "";
  matchFlag = "";
  spanStart = '<span class="text-highlight">';
  spanEnd = "</span>";

  @Input("content")
  set content(content: string) {
    this._content = content;
  }
  get content(): string {
    return this._content;
  }

  @Input("searchTerm")
  set searchTerm(searchTerm: string) {
    this._searchTerm = searchTerm;
    this.highlight();
  }
  get searchTerm(): string {
    return this._searchTerm;
  }

  @Input() caseSensitive: boolean;

  constructor(private el: ElementRef) {
    this.caseSensitive = false;
  }

  highlight() {
    this.final = "";
    if (!this.caseSensitive) {
      this.splitFlag = "i";
      this.matchFlag = "gi";
    } else {
      this.splitFlag = "";
      this.matchFlag = "g";
    }
    this.searchPattern = new RegExp(this._searchTerm, this.splitFlag);
    this.matchpattern = new RegExp(this._searchTerm, this.matchFlag);

    if (
      this._searchTerm !== undefined &&
      this._searchTerm != null &&
      this._searchTerm.length > 0 &&
      this._searchTerm[0] !== "."
    ) {
      this.separatedText = this._content.split(this.searchPattern);
      this.separatedSearchedText = this._content.match(this.matchpattern);

      if (
        this.separatedSearchedText != null &&
        this.separatedSearchedText.length > 0
      ) {
        for (let i = 0; i < this.separatedText.length; i++) {
          if (i <= this.separatedSearchedText.length - 1) {
            this.final +=
              this.separatedText[i] +
              this.spanStart +
              this.separatedSearchedText[i] +
              this.spanEnd;
              if (this.separatedSearchedText[i] && this._content == (this.territoryResolution || this.territoryResolutionAzure || this.territoryResolutionCrm || this.territoryResolutionNalco || this.territoryResolutionOst )){
                var points = document.getElementById("points");

                var showMoreText = document.getElementById("moreText");

                var buttonText = document.getElementById("textButton");

                showMoreText!.style.display = "inline";

                points!.style.display = "none";

                buttonText!.innerHTML = "Show Less";

              }
              if (this.separatedSearchedText[i] && this._content == (this.incorrectShiptoResolution || this.incorrectShiptoResolutionOst)){
                var incorrectShiptoPoints = document.getElementById("incorrectShiptoPoints");

                var incorrectShiptoMoreText = document.getElementById("incorrectShiptoMoreText");

                var incorrectShiptoButton = document.getElementById("incorrectShiptoButton");

                incorrectShiptoMoreText!.style.display = "inline";

                incorrectShiptoPoints!.style.display = "none";

                incorrectShiptoButton!.innerHTML = "Show Less";

              }
              if (this.separatedSearchedText[i] && this._content == (this.logisticsResolutionCloudera || this.logisticsResolutionOst)){
                var logisticsPoints = document.getElementById("logisticsPoints");

                var logisticsMoreText = document.getElementById("logisticsMoreText");

                var logisticsButton = document.getElementById("logisticsButton");

                logisticsMoreText!.style.display = "inline";

                logisticsPoints!.style.display = "none";

                logisticsButton!.innerHTML = "Show Less";

              }
              if (this.separatedSearchedText[i] && this._content == this.errorScreenResolution){
                var errorScreenPoints = document.getElementById("errorScreenPoints");

                var errorScreenMoreText = document.getElementById("errorScreenMoreText");

                var errorScreenButton = document.getElementById("errorScreenButton");

                errorScreenMoreText!.style.display = "inline";

                errorScreenPoints!.style.display = "none";

                errorScreenButton!.innerHTML = "Show Less";

              }
          } else {
            this.final += this.separatedText[i];
          }
        }
      }
      if (this.final.length > 0) {
        this.el.nativeElement.innerHTML = this.final;
      } else {
        this.el.nativeElement.innerText = this._content;
      }
    } else {
      this.el.nativeElement.innerHTML = this._content;
    }
  }


  territoryResolution = 'There could be issues in the CRM Regarding territory assignment, to rectify this please raise a ticket Service now to the below assignment group with User email ID & Expected Territories'
  territoryResolutionNalco = 'If Nalco Water or Food & Beverage User, escalate to GBS-TCS-MSDynamics-CRM/ TCS-SAP-CRMSD'
  territoryResolutionAzure = 'Else, assign the incident to GBS-TCS-AZURE/ TCS-SAP-CRMSD team'
  territoryResolutionCrm = 'If there are no issues in CRM, then there could be an issue with our data import, to rectify this'
  territoryResolutionOst = 'Raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  incorrectShiptoResolution = 'There could be issues in the Informatica DB, to rectify this please raise a ticket (Service now) to the “GBS-TCS-INFORMATICA MDM “group with User email ID & Expected Territories'
  incorrectShiptoResolutionOst = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  logisticsResolutionCloudera = 'There could be issues in the data delivery from the 3rd party, to rectify this please raise a ticket (Service now) to the “TCS-nonSAP-CLOUDERA “group with User email ID & Expected Territories'
  logisticsResolutionOst = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  errorScreenResolution = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'

}
